import Vue from 'vue'
import App from './app.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
// import {
//     Message
// } from 'element-ui'
Vue.use(ElementUI)
import './base.css'
import './main.less'
// import axios from 'axios'
import http from './http.js' //axios实例化后引入取名http
import permission from './permission';
window.domain=http.domain;
Vue.use(permission);

Vue.prototype.http = http //放入全局
Vue.prototype.domain = http.domain; //放入全局
Vue.config.productionTip = false
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

const app = new Vue({
    router,
    render: h => h(App),
    data: function() {
        return {
            userInfo: '',
        };
    }
}).$mount('#app');
window.app = app.$mount('#app')